<template>
	<div class="page-user-lsit">
		<div class="pg-breadcrumb">
			<div class="breadcrumb-item em">派送專線</div>
			<div class="breadcrumb-item">派送時間設定</div>
		</div>

		<div class="card-block pd-bt">
			<div class="pg-toolbar">
				<div class="pg-btn-wrap">
					<span style="margin-right:10px;font-family: PingFang SC;font-weight: bold;">派送時間設定列表</span>
					<div class="pg-btn" @click="handleBack()">返回</div>
				</div>
				<div class="pg-btn">默認周一到周五派送時間為16:00-22:00，周六日派送時間為00:00-23:59，如需修改請點擊對應日期</div>
			</div>
			<sy-date-picker-special
					class="calendar"
					:showDefault="true"
					:data-info-list="dataInfoList"
					@handleClickDay="handleClickDay"
					@handlePrevMonth="handlePrevMonth"
					@handleNextMonth="handleNextMonth"
					@handleResetTime="handleResetTime"
			>
				<template v-slot:default="{dateInfo}">
					<div class="inner-time">
						<span>派送时间段：</span>
						<div>{{dateInfo.dataInfo.start_time}}</div>
						<span>---</span>
						<div>{{dateInfo.dataInfo.end_time}}</div></div>
				</template>
			</sy-date-picker-special>

		</div>
	</div>
</template>

<script>
   import syDatePicker from 'sy-date-picker-special'
   import 'sy-date-picker-special/lib/date-picker.css'

   export default {
      components: {'syDatePickerSpecial': syDatePicker.DatePicker},
      data() {
         return {
            pageParamID: null,
            dataInfoList: []
         };
      },
      created() {
         this.pageParamID = this.$route.query?.id;
         this.getList()
      },
      mounted() {

      },
      methods: {
         async getList() {
            const {code, data: {data}} = await this.$Rq.requestAuth({
               url: this.$Api.deliveryareaDateList, method: 'get',
               data: {
                  d_id: this.pageParamID
               }
            })
            if (code === 0) {
               this.dataInfoList = data?.map(item => {
                  item.time = item.day
                  if (!item.start_time && !item.end_time) {
                     item.clickDay = true
                  }
                  return item;
               })
            }
         },
         async handleClickDay(item) {
            console.log('点击当天不派送', item)
            let url, data;

            if (item.clickDay === false) { // 删除
               console.log('删除当天不派送')
               url = this.$Api.deliveryareaDateDel
               data = {
                  id: item.dataInfo.id,
               }
            } else { // 新增
               console.log('新增当天不派送')
	             if (item.dataInfo.id) { // 修改
	                url = this.$Api.deliveryareaDateEidt
                  data = {
	                   id: item.dataInfo.id,
                     d_id: this.pageParamID,
                     day: item.dataStatus,
                     start_time: '',
                     end_time: ''
                  }
	             }else { // 新增
                  url = this.$Api.deliveryareaDateAdd;
                  data = {
                     d_id: this.pageParamID,
                     day: item.dataStatus,
                     start_time: '',
                     end_time: ''
                  }
	             }
            }

            const {msg} = await this.$Rq.requestAuth({url, method: 'post', data})
            this.$message.success(msg)
            this.getList();
         },
         handlePrevMonth(date) {
            console.log('上一月', date)
         },
         handleNextMonth(date) {
            console.log('下一月', date)
         },
         async handleResetTime(item) {
            console.log('点击重置时间', item)
            let url, data = {
               d_id: this.pageParamID,
               day: item.dataStatus,
               start_time: item.selectStartTime,
               end_time: item.selectEndTime
            };
            if (item.dataInfo.id) { // 修改
               if (item.selectStartTime || item.selectEndTime) {
                  if (!data.start_time || !data.end_time) return this.$message.error('请选择开始时间和结束时间')
               }
               url = this.$Api.deliveryareaDateEidt
               data.id = item.dataInfo.id
            } else { // 新增
               if (!data.start_time || !data.end_time) return this.$message.error('请选择开始时间和结束时间')
               url = this.$Api.deliveryareaDateAdd
            }

            const {msg} = await this.$Rq.requestAuth({url, method: 'post', data})
            this.$message.success(msg)
            this.getList();
         },
         handleBack() {
            this.$router.go(-1);
         },
      }
   };
</script>
<style lang="scss">
	.cc-calendar .calendar-view .date-view {
		padding: 10px 6px 12px;
	}

	.cc-calendar .calendar-view .date-view .showcalendar {
		visibility: visible !important;
	}

	.inner-time {
		color: #333;
		line-height: 16px;
		margin-top: 10px;
		font-size: 14px;
		text-align: center;
		div {
			color: #16ec16;
		}
	}
</style>
<style lang="scss" scoped>
	@import 'deliveryareatimeSetting.scss';
</style>
